import React from 'react';
import './App.css';
import Footer from './footer/footer.js';
import Header from './header/header.js';
import Home from './home/Home';

const App = () => (
  <div className="App">
    <Header />
    <main>
      <Home />
    </main>
    <Footer />
  </div>
);

export default App;
